import { useQuery } from '@tanstack/react-query';
import { fetchSubmissionReviews, fetchSubmissionReviewsSummary } from 'src/api/queries';

import { Flex, Text } from '@chakra-ui/react';
import { Badge, OutlineCard, ButtonText } from '@morressier/alembic';
import { faBan, faCheck, faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Highlights from './Highlights';
import { SUBMISSION_DETAIL_TABS } from 'src/pages/SubmissionDetails';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { useSubmissionDetails } from 'src/pages/SubmissionDetails/SubmissionDetailsContext';
import AdditionalInformationWrapper from '../../AdditionalInformationWrapper';

export const ReviewStates = {
  invited: (
    <Badge variant="neutral" size="context">
      <FontAwesomeIcon icon={faEnvelope} /> Invited
    </Badge>
  ),
  declined: (
    <Badge variant="caution" size="context">
      <FontAwesomeIcon icon={faBan} /> Declined
    </Badge>
  ),
  inReview: (
    <Badge variant="attention" size="context">
      <FontAwesomeIcon icon={faCheck} /> Accepted
    </Badge>
  ),
  reviewed: (
    <Badge variant="success" size="context">
      <FontAwesomeIcon icon={faCheck} /> Reviewed
    </Badge>
  )
} as const;

export const PeerReviewAdditionalInfo = () => {
  const { setActiveTab } = useSubmissionDetails();
  const { submissionId, submissionContextId, workflowResponse } =
    useSubmissionData();
  const queryKey = ['review-list', { submissionContextId, submissionId }];

  const { data: reviews, isLoading } = useQuery({
    queryKey,
    queryFn: () => fetchSubmissionReviews(submissionContextId, submissionId)
  });

   const { data: reviewsSummary} = useQuery({
    queryKey:['summary-count', { submissionContextId, submissionId }],
    queryFn: () => fetchSubmissionReviewsSummary(submissionContextId, submissionId)
  });

  if (isLoading)
    return (
      <AdditionalInformationWrapper>
        <div>loading</div>
      </AdditionalInformationWrapper>
    );

  const showViewReviewsButton = reviews?.items.some(
    review => review.workflow.currentState === 'reviewed'
  );

  return (
    <AdditionalInformationWrapper>
      <OutlineCard borderless width="100%">
        <Flex flexDirection="column" gap={2}>
          <Flex justify="space-between">
            <Text textStyle="headingOverline" textTransform="uppercase">
              HIGHLIGHTS
            </Text>

            {showViewReviewsButton && (
              <ButtonText
                onClick={() => setActiveTab(SUBMISSION_DETAIL_TABS.REVIEWS)}
              >
                View Reviews
              </ButtonText>
            )}
          </Flex>
          <Highlights
            workflowData={workflowResponse.workflowData}
            reviews={reviews}
            submissionId={submissionId}
            highlightSummaryCounts={reviewsSummary?.highlightsCounts}
          />

          {/* TODO: remove this once actual logic is in place, keeping here for quick testing / visualizing */}
          {/* <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Flex flexDirection="column" gap={4}>
              {mockFieldConfig.map(field => (
                <CustomFormFieldComponent key={field.name} config={field} />
              ))}

              <Button type="submit">Submit</Button>
            </Flex>
          </form>
        </FormProvider> */}
        </Flex>
      </OutlineCard>
    </AdditionalInformationWrapper>
  );
};
